import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetPlacesByCategoryUidApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            placeCategory: z.object({
                documentId: z.string(),
                slug: z.string(),
                name: z.string(),
            }).optional().nullable(),
        }),
    ),
});

type GetPlacesByCategoryUidApiResponse
    = ApiResponse<z.infer<typeof GetPlacesByCategoryUidApiResponseSchema>>
    | BaseError;

type GetPlacesByCategoryUidActionRequest = {
    uid: string
}

export const getPlacesByCategory = createAsyncThunk<
    GetPlacesByCategoryUidApiResponse,
    GetPlacesByCategoryUidActionRequest
>(
    'PlacesPageActionsGetPlacesByCategoryUid',
    async ({
        uid,
    }) => apiInstance.get(
        '/places',
        {
            'filters[placeCategory][slug][$eq]': uid,
            'populate[images][fields]': 'url',
            'populate[placeCategory][fields]': '*',
        },
        GetPlacesByCategoryUidApiResponseSchema,
    ),
);
